module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-72x72-6610bc966e78dcef587a00fdbe3996d6.png";